import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAddCommentMutation } from "../messageApiSlice"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSave } from "@fortawesome/free-solid-svg-icons"

const AddComment = ({messageId})=>{
    const [title, setTitle] = useState("")
    const {groupId} = useParams()
    const [addComment, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddCommentMutation()

    const navigate = useNavigate()
    useEffect(() => {

        if (isSuccess ) {
            setTitle('')
        }

    }, [isSuccess, navigate])



    const canSave = [title].every(Boolean) && !isLoading

    const onAddCommentClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addComment({ messageId: messageId,title })
        }
    }

    const validTitleClass = !title ? "form__input--incomplete" : ''

    return <>
    <form className="form" onSubmit={onAddCommentClicked}>
   
<div className="d-flex" style={{marginTop:"5px"}}>
             
        <input
            style={{flex:1}}
            className={`form__input `}
            id="title"
            title="title"
            maxLength={70}
            placeholder="הוספת תגובה / הערה"
            type="text"
            autoComplete="off"
            value={title}
            onChange={e=>setTitle(e.target.value)}
        />
           <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>  
        </div>
    </form>
</>

}
export default AddComment